var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-main-inner',{attrs:{"title":"订单"}},[_c('template',{slot:"action"}),_c('layout-card-wrap',[_c('order-table-all',{ref:"table_1",attrs:{"edit":false}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }